import { __decorate, __extends } from "tslib";
import { Component } from 'vue-property-decorator';
import AbpBase from '@/lib/AbpBase';
import { OrganizationUnitServiceProxy } from '@/lib/service-proxy/service-proxies';
import arrayToTree from 'array-to-tree';
import Template from './RoleViewModal.html';
import { PermissionDto } from './CreateOrUpdateRole';
var RoleViewModal = /** @class */ (function (_super) {
    __extends(RoleViewModal, _super);
    function RoleViewModal() {
        var _this = _super.call(this) || this;
        _this.visible = false;
        _this.service = new OrganizationUnitServiceProxy();
        return _this;
    }
    Object.defineProperty(RoleViewModal.prototype, "permissions", {
        get: function () {
            // 去除父节点的选中状态
            var grantedPermissions = this.removeParentPermissions();
            var scopePermissions = this.$store.state.role.permissions.map(function (permission) {
                var treeDto = new PermissionDto(permission);
                treeDto.title = permission.displayName;
                treeDto.expand = treeDto.name.split('.').length < 2;
                treeDto.checked = grantedPermissions.findIndex(function (c) { return c.name === permission.name; }) >= 0;
                return treeDto;
            });
            scopePermissions.forEach(function (item) {
                return (item.checked = scopePermissions.filter(function (c) { return c.parentName === item.name; }).length === 0 && item.checked);
            });
            var treeData = arrayToTree(scopePermissions, {
                parentProperty: 'parentName',
                customID: 'name'
            });
            return treeData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoleViewModal.prototype, "dto", {
        get: function () {
            return this.$store.state.role.editRole;
        },
        enumerable: true,
        configurable: true
    });
    RoleViewModal.prototype.open = function () {
        var _this = this;
        this.visible = true;
        this.service.getPositionsByRole(this.dto.id).then(function (result) {
            _this.positions = result.items;
        });
    };
    RoleViewModal.prototype.removeParentPermissions = function () {
        var _this = this;
        var grantedPermissions = this.$store.state.role.permissions.filter(function (item) {
            return _this.$store.state.role.grantedPermissionNames.indexOf(item.name) >= 0;
        });
        var cloneGranted = [].concat(grantedPermissions);
        var _loop_1 = function (element) {
            var parentIndex = grantedPermissions.findIndex(function (c) { return c.name === element.parentName; });
            if (parentIndex >= 0) {
                grantedPermissions.splice(parentIndex, 1);
            }
        };
        for (var _i = 0, cloneGranted_1 = cloneGranted; _i < cloneGranted_1.length; _i++) {
            var element = cloneGranted_1[_i];
            _loop_1(element);
        }
        return grantedPermissions;
    };
    RoleViewModal.prototype.handleCloseClick = function () {
        this.visible = false;
    };
    RoleViewModal = __decorate([
        Template,
        Component
    ], RoleViewModal);
    return RoleViewModal;
}(AbpBase));
export default RoleViewModal;
